import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import Button from 'components/util/Button'
import styles from './_goalsHeader.css'

export default function GoalsHeader ({ userId, showCreateButton }) {
  return (
    <div className={styles.goalsHeaderContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.mainTitle}>
          <FormattedMessage
            id='goals.title.main'
            defaultMessage='Achieve your best' />
        </div>
        <div className={styles.subTitle}>
          <FormattedMessage
            id='goals.title.sub'
            defaultMessage='Stay on target with a weekly goal' />
        </div>
      </div>
      {showCreateButton ?
        <Link className={styles.createLink} to={`/profile/${userId}/goals/create`}>
          <Button
            el='button'
            type='action'
            size='medium'
            className={styles.createGoalButton}>
            <FormattedMessage
              id='creategoal.link'
              defaultMessage='Create a goal' />
          </Button>
        </Link> : null}
    </div>
  )
}

GoalsHeader.propTypes = {
  userId: PropTypes.string,
  showCreateButton: PropTypes.bool,
}

GoalsHeader.defaultProps = {
  showCreateButton: true,
}
